
import Vue from 'vue';
import { getxiaozusai } from '../api';

export default Vue.extend({
  data() {
    return {
      sessionList: [] as {
        name: string;
        matches: {
          leftTeam: string;
          leftScore: string;
          rightTeam: string;
          rightScore: string;
          time: string;
        }[];
      }[],
    };
  },
  async created() {
    try {
      const ret: any = await getxiaozusai();
      if (ret.code === 200 && Array.isArray(ret.data) && ret.data.length) {
        this.sessionList = this.buildSessionList(ret.data);
      } else {
        this.sessionList = [];
      }
    } catch (e) {
      console.error('获取淘汰赛数据失败', e);
    }
  },
  methods: {
    buildSessionList(data: any[]) {
      const map: Record<string, any[]> = {};
      data.forEach((item) => {
        const name = item.session_name || '淘汰赛';
        if (!map[name]) {
          map[name] = [];
        }
        map[name].push(item);
      });

      return Object.keys(map).map((name) => ({
        name,
        matches: map[name].map((item) => {
          const isNotStarted = Number(item.mode) === 1;
          return {
            leftTeam: item.item_one_name || '',
            leftScore:
              !isNotStarted && item.item_one_points != null
                ? item.item_one_points
                : '',
            rightTeam: item.item_two_name || '',
            rightScore:
              !isNotStarted && item.item_two_points != null
                ? item.item_two_points
                : '',
            time: item.match_date_text || '',
          };
        }),
      }));
    },
  },
});
